var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3858 2.57143H10.9111V0.642857C10.9111 0.472361 10.8434 0.308848 10.7231 0.188288C10.6027 0.0677294 10.4395 0 10.2692 0H5.13461C4.96439 0 4.80114 0.0677294 4.68077 0.188288C4.56041 0.308848 4.49279 0.472361 4.49279 0.642857V2.57143H0.0180513L0 4.17857H1.32377L2.12966 16.7946C2.15006 17.1209 2.29376 17.4271 2.53155 17.651C2.76933 17.8749 3.08334 17.9997 3.4097 18H11.9941C12.3203 18 12.6343 17.8755 12.8722 17.652C13.1101 17.4285 13.2541 17.1227 13.275 16.7967L14.0801 4.17857H15.4038L15.3858 2.57143ZM4.49279 15.4286L4.13176 5.14286H5.45553L5.81656 15.4286H4.49279ZM8.34375 15.4286H7.06009V5.14286H8.34375V15.4286ZM9.30649 2.57143H6.09735V1.44643C6.09735 1.4038 6.11426 1.36293 6.14435 1.33279C6.17444 1.30265 6.21526 1.28571 6.25781 1.28571H9.14603C9.18859 1.28571 9.2294 1.30265 9.25949 1.33279C9.28958 1.36293 9.30649 1.4038 9.30649 1.44643V2.57143ZM10.9111 15.4286H9.58729L9.94832 5.14286H11.2721L10.9111 15.4286Z",
    fill: "#BEBEBE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/Trash.5d2a32c7.svg";
export { ForwardRef as ReactComponent };